<template>
  <div class=" stack-item order-process-status">
    <div class="steps steps-vertical">
      <div class="created-date">{{ createdDate }}</div>
      <StatusStep v-for="(step, index) in cleanedSteps" :key="step.id" :index="`${index + 1}`" :title="$t(step.label)"
        :status="step.status" :isProcessing="step.isProcessing" :subTitle="step.subTitle">
        <div v-if="
          step.status === enableStepContent || step.status === failStepContent
        ">
          <div class="step-completed-time">{{ step.time }}</div>
          <div v-if="step.description">{{ step.description }}</div>
          <div v-if="step.toolTip && data.status === 'IDLE'" class="step-tool-tip">
            {{ step.toolTip }}
          </div>
          <div class="step-recipient-id" v-if="step.por_info && !step.porImage">
            <span>{{ $t("SHARE_ORDER.recipientId") }}: </span>
            <span>{{ step.por_info }}</span>
          </div>
          <figure v-if="step.por_info && step.porImage" class="image fail-image" @click="handleClickPorInfo">
            <img :src="step.por_info" />
          </figure>
          <b-modal :active.sync="isImageModalActive" v-if="step.por_info && step.porImage">
            <p class="image fail-image-modal is-4by3" style="background-color:#ffffff;">
              <img :src="step.por_info" />
            </p>
          </b-modal>
        </div>
      </StatusStep>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
// const { ORDER_STATUS, STEP_STATUS } = Vue.prototype.$constants
import { ORDER_STATUS, STEP_STATUS } from "@/mixins/constants";
import StatusStep from "./StatusStep";

export default {
  name: "StatusProcess",
  props: {
    data: Object,
  },
  components: {
    StatusStep,
  },
  data: () => {
    return {
      steps: [],
      cleanedSteps: [],
      isImageModalActive: false,
      enableStepContent: STEP_STATUS.ENABLED,
      failStepContent: STEP_STATUS.FAILED,
    };
  },
  computed: {
    createdDate() {
      let createTime = "";
      if (this.data.create_time && this.data.create_time > 0) {
        createTime = this.$dayjs
          .unix(this.data.create_time)
          .format(this.$store.getters.formatTime);
      }

      return createTime;
    },
  },
  methods: {
    updateStepsInfo() {
      const orderHasFailedStoppoint = this.data.orderHasFailedStoppoint;
      const now = new Date().getTime() / 1000;
      let currentStatusIndex = null;

      // Check and set properties to each step
      this.steps.forEach((step, index) => {
        let time = this.data[step.timeFieldKey];
        switch (step.id) {
          case ORDER_STATUS.CANCELLED:
            step.visible = this.data.status === ORDER_STATUS.CANCELLED;
            step.status = STEP_STATUS.FAILED;
            // step.description = this.data.cancel_comment
            break;
          case ORDER_STATUS.IDLE:
            step.visible = this.data.idle_until > 0;
            step.status = STEP_STATUS.ENABLED;
            if (this.data.idle_until && this.data.idle_until > now && ![this.$constants.PARTNER.ANCUONG].includes(this.data.partner)) {
              step.toolTip = this.$t("SHARE_ORDER.TOOL_TIPS.IDLE", {
                time: this.formatOrderTime(this.data.idle_until),
              });
            } else {
              step.toolTip = "";
            }
            break;
          case ORDER_STATUS.ASSIGNING:
            step.visible = true;
            step.status =
              !this.data.idle_until ||
                this.data.order_time <= now ||
                this.data.accept_time > 0
                ? STEP_STATUS.ENABLED
                : STEP_STATUS.DISABLED;
            step.isProcessing = step.status && step.id === this.data.status;
            break;
          // case ORDER_STATUS.VERIFYING:
          //     step.visible = true
          //     step.status = STEP_STATUS.ENABLED
          //     step.isProcessing = false
          //     break
          case ORDER_STATUS.IN_PROCESS: // === PICKED_UP
            step.visible = true;
            step.status =
              this.data[step.timeFieldKey] > 0 ||
                (this.data.board_time > 0 &&
                  [
                    ORDER_STATUS.IN_PROCESS,
                    ORDER_STATUS.COMPLETED,
                    ORDER_STATUS.FAILED,
                    ORDER_STATUS.RETURNED,
                  ].includes(this.data.status))
                ? STEP_STATUS.ENABLED
                : STEP_STATUS.DISABLED;

            if (
              !this.data[step.timeFieldKey] &&
              this.data.status === ORDER_STATUS.COMPLETED
            ) {
              step.status = STEP_STATUS.ENABLED;
            }

            if (!time) time = this.data.board_time;
            break;
          // case ORDER_STATUS.IN_PROCESS:
          //     step.visible = true
          //     step.status = this.data[step.timeFieldKey] > 0
          //         ? STEP_STATUS.ENABLED
          //         : STEP_STATUS.DISABLED
          //     step.isProcessing = step.status && !this.data.complete_time && !this.data.fail_time && !this.data.cancel_time
          //     break
          // case ORDER_STATUS.RETURNING:
          //     step.visible = this.data.notify_package_return === true && this.data.status === ORDER_STATUS.COMPLETED && orderHasFailedStoppoint
          //     step.status = this.data[step.timeFieldKey] > 0
          //         ? STEP_STATUS.ENABLED
          //         : STEP_STATUS.DISABLED
          //     step.isProcessing = step.status && !this.data.return_time
          //     break
          case ORDER_STATUS.RETURNED:
            step.visible =
              this.data.notify_package_return === true &&
              (this.data.status === ORDER_STATUS.COMPLETED ||
                this.data.status === ORDER_STATUS.FAILED) &&
              orderHasFailedStoppoint;
            step.status =
              this.data[step.timeFieldKey] > 0
                ? STEP_STATUS.ENABLED
                : STEP_STATUS.DISABLED;
            if (this.data.por_info) {
              const regex = /(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/g;
              if (regex.test(this.data.por_info)) {
                step.porImage = true;
              }
              step.por_info = this.data.por_info;
            }
            break;
          case ORDER_STATUS.COMPLETED:
            step.visible =
              !(orderHasFailedStoppoint && this.data.path.length === 2) &&
              this.data.status !== ORDER_STATUS.FAILED;
            step.status =
              this.data[step.timeFieldKey] > 0
                ? STEP_STATUS.ENABLED
                : STEP_STATUS.DISABLED;
            if (orderHasFailedStoppoint) {
              step.subTitle = `(${this.data.successPoint}/${this.data.stopPoint})`;
            }
            break;
          case ORDER_STATUS.FAILED:
            step.visible = this.data.status === ORDER_STATUS.FAILED;
            step.status =
              this.data[step.timeFieldKey] > 0
                ? STEP_STATUS.ENABLED
                : STEP_STATUS.DISABLED;
            // step.description = this.data.fail_comment
            break;
          default:
            step.status =
              this.data[step.timeFieldKey] > 0
                ? STEP_STATUS.ENABLED
                : STEP_STATUS.DISABLED;
            break;
        }

        // Exclude CANCELLED(currentStatusIndex = 0) & RETURNED status to this filter
        if (
          currentStatusIndex &&
          step.id !== ORDER_STATUS.RETURNED &&
          index > currentStatusIndex
        ) {
          step.status = STEP_STATUS.DISABLED;
        }

        if (this.data.status === step.id) {
          currentStatusIndex = index;
        }

        if (time > 0) {
          step.time = this.formatOrderTime(time);
        }
      });

      this.cleanedSteps = [];
      this.steps.forEach((step, index) => {
        if (step.visible && index > 0) {
          this.cleanedSteps.push(step);

          if (
            this.data.status === ORDER_STATUS.CANCELLED &&
            step.status === STEP_STATUS.ENABLED
          ) {
            let nextStepIsDiabled = !(
              this.steps[index + 1] &&
              this.steps[index + 1].status === STEP_STATUS.ENABLED
            );
            if (nextStepIsDiabled) {
              this.cleanedSteps.push(this.steps[0]);
            }
          }
        }
      });
    },
    formatOrderTime(time) {
      const createTime = this.$dayjs.unix(this.data.create_time);
      const momentTime = this.$dayjs.unix(time);
      const format = createTime.isSame(momentTime, "day")
        ? this.$store.getters.formatSameDayTime
        : this.$store.getters.formatDiffDayTime;
      return momentTime.format(format);
    },
    handleClickPorInfo() {
      this.isImageModalActive = true;
    },
    initSteps() {
      const stepsOrderStatus = [
        {
          id: ORDER_STATUS.CANCELLED,
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.CANCELLED",
          timeFieldKey: "cancel_time",
        },
        {
          id: "CREATED",
          visible: true,
          status: STEP_STATUS.ENABLED,
          label: "SHARE_ORDER.ORDER_STATUS.CREATED",
          timeFieldKey: "create_time",
        },
        {
          id: ORDER_STATUS.IDLE,
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.IDLE",
          timeFieldKey: "create_time",
        },
        // {
        //     id: ORDER_STATUS.VERIFYING,
        //     visible: true,
        //     status: STEP_STATUS.DISABLED,
        //     label: "SHARE_ORDER.ORDER_STATUS.VERIFYING",
        //     timeFieldKey: "order_time",
        // },
        // {
        //     id: ORDER_STATUS.WAITING_FOR_RO,
        //     visible: true,
        //     status: STEP_STATUS.DISABLED,
        //     label: "SHARE_ORDER.ORDER_STATUS.WAITING_FOR_RO",
        //     timeFieldKey: "order_time",
        // },
        {
          id: ORDER_STATUS.ASSIGNING,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.ASSIGNING",
          timeFieldKey: "order_time",
        },
        {
          id: ORDER_STATUS.ACCEPTED,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.ACCEPTED",
          timeFieldKey: "accept_time",
        },
        {
          id: ORDER_STATUS.BOARDED, // Sub status
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.BOARDED",
          timeFieldKey: "board_time",
        },
        {
          id: ORDER_STATUS.IN_PROCESS,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.PICKED_UP",
          timeFieldKey: "pickup_time",
        },

        {
          id: ORDER_STATUS.COMPLETED,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.COMPLETED",
          timeFieldKey: "complete_time",
        },
        {
          id: ORDER_STATUS.FAILED, // Custom status
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.FAILED",
          timeFieldKey: "fail_time",
        },

        {
          id: ORDER_STATUS.RETURNED,
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.RETURNED",
          timeFieldKey: "return_time",
        },
      ];

      const stepsOrderRideStatus = [
        {
          id: ORDER_STATUS.CANCELLED,
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.CANCELLED",
          timeFieldKey: "cancel_time",
        },

        {
          id: ORDER_STATUS.IDLE,
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.IDLE",
          timeFieldKey: "create_time",
        },

        {
          id: ORDER_STATUS.ASSIGNING,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.ASSIGNING",
          timeFieldKey: "order_time",
        },
        {
          id: ORDER_STATUS.ACCEPTED,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.ACCEPTED",
          timeFieldKey: "accept_time",
        },
        {
          id: ORDER_STATUS.BOARDED, // Sub status
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.BOARDED",
          timeFieldKey: "arrive_time",
        },
        {
          id: ORDER_STATUS.IN_PROCESS,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.IN_PROCESS",
          timeFieldKey: "pickup_time",
        },
        {
          id: ORDER_STATUS.COMPLETED,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.COMPLETED",
          timeFieldKey: "complete_time",
        },
        {
          id: ORDER_STATUS.FAILED, // Custom status
          visible: false,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_RIDE_STATUS.FAILED",
          timeFieldKey: "fail_time",
        },
      ];
      console.log("stepsOrderRideStatus", stepsOrderRideStatus);

      this.data.order_type === this.$constants.ORDER_TYPE.RIDE
        ? (this.steps = stepsOrderRideStatus)
        : (this.steps = stepsOrderStatus);
    },
    updateStepsRideInfo() {
      const now = new Date().getTime() / 1000;
      let currentStatusIndex = null;

      // Check and set properties to each step
      this.steps.forEach((step, index) => {
        this.data.status_logs.forEach((stepRide) => {
          {
            switch (step.id) {
              case ORDER_STATUS.CANCELLED:
                step.visible = this.data.status === ORDER_STATUS.CANCELLED;
                step.status = STEP_STATUS.FAILED;

                break;
              case ORDER_STATUS.IDLE:
                step.visible = this.data.idle_until > 0;
                step.status = STEP_STATUS.ENABLED;
                if (this.data.idle_until && this.data.idle_until > now && ![this.$constants.PARTNER.ANCUONG].includes(this.data.partner)) {
                  step.toolTip = this.$t("SHARE_ORDER.TOOL_TIPS.IDLE", {
                    time: this.formatOrderTime(this.data.idle_until),
                  });
                } else {
                  step.toolTip = "";
                }
                break;
              case ORDER_STATUS.ASSIGNING:
                step.visible = true;
                step.status =
                  !this.data.idle_until ||
                    this.data.order_time <= now ||
                    this.data.accept_time > 0
                    ? STEP_STATUS.ENABLED
                    : STEP_STATUS.DISABLED;
                step.isProcessing = step.status && step.id === this.data.status;
                break;

              case ORDER_STATUS.BOARDED:
                if (
                  stepRide.status === ORDER_STATUS.ACCEPTED &&
                  stepRide.sub_status === "ARRIVED"
                ) {
                  step.visible = true;
                  step.status =
                    this.data.arrive_time > 0
                      ? STEP_STATUS.ENABLED
                      : STEP_STATUS.DISABLED;
                }
                break;

              case ORDER_STATUS.IN_PROCESS: // === PICKED_UP
                step.visible = true;
                step.status =
                  this.data[step.timeFieldKey] > 0 ||
                    (this.data.board_time > 0 &&
                      [
                        ORDER_STATUS.IN_PROCESS,
                        ORDER_STATUS.COMPLETED,
                        ORDER_STATUS.FAILED,
                        ORDER_STATUS.RETURNED,
                      ].includes(this.data.status))
                    ? STEP_STATUS.ENABLED
                    : STEP_STATUS.DISABLED;

                if (
                  !this.data[step.timeFieldKey] &&
                  this.data.status === ORDER_STATUS.COMPLETED
                ) {
                  step.status = STEP_STATUS.ENABLED;
                }

                if (!time) time = this.data.board_time;
                break;

              case ORDER_STATUS.COMPLETED:
                step.visible = this.data.status !== ORDER_STATUS.FAILED;
                step.status =
                  this.data[step.timeFieldKey] > 0
                    ? STEP_STATUS.ENABLED
                    : STEP_STATUS.DISABLED;

                break;
              case ORDER_STATUS.FAILED:
                step.visible = this.data.status === ORDER_STATUS.FAILED;
                step.status =
                  this.data[step.timeFieldKey] > 0
                    ? STEP_STATUS.ENABLED
                    : STEP_STATUS.DISABLED;
                // step.description = this.data.fail_comment
                break;
              default:
                step.status =
                  this.data[step.timeFieldKey] > 0
                    ? STEP_STATUS.ENABLED
                    : STEP_STATUS.DISABLED;
                break;
            }
          }
        });
        let time = this.data[step.timeFieldKey];

        // Exclude CANCELLED(currentStatusIndex = 0) & RETURNED status to this filter
        if (
          currentStatusIndex &&
          step.id !== ORDER_STATUS.RETURNED &&
          index > currentStatusIndex
        ) {
          step.status = STEP_STATUS.DISABLED;
        }

        if (this.data.status === step.id) {
          if (this.data.sub_status === "ARRIVED") {
            currentStatusIndex = index + 1;
          } else {
            currentStatusIndex = index;
          }
        }

        if (time > 0) {
          step.time = this.formatOrderTime(time);
        }
      });

      this.cleanedSteps = [];
      this.steps.forEach((step, index) => {
        if (step.visible && index > 0) {
          this.cleanedSteps.push(step);

          if (
            this.data.status === ORDER_STATUS.CANCELLED &&
            step.status === STEP_STATUS.ENABLED
          ) {
            let nextStepIsDiabled = !(
              this.steps[index + 1] &&
              this.steps[index + 1].status === STEP_STATUS.ENABLED
            );
            if (nextStepIsDiabled) {
              this.cleanedSteps.push(this.steps[0]);
            }
          }
        }
      });
    },
  },
  beforeMount() {
    this.initSteps();
    if (
      this.data.status_logs &&
      this.data.order_type !== this.$constants.ORDER_TYPE.RIDE
    ) {
      console.log("is warehouse order");
      this.steps.splice(
        2,
        0,
        {
          id: ORDER_STATUS.VERIFYING,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.VERIFYING",
          timeFieldKey: "order_time",
        },
        {
          id: ORDER_STATUS.WAITING_FOR_RO,
          visible: true,
          status: STEP_STATUS.DISABLED,
          label: "SHARE_ORDER.ORDER_STATUS.WAITING_FOR_RO",
          timeFieldKey: "order_time",
        }
      );
    }
    if (this.data.order_type !== this.$constants.ORDER_TYPE.RIDE) {
      this.updateStepsInfo();
    } else {
      this.updateStepsRideInfo();
    }
  },
  beforeUpdate() {
    //do something before updating vue instance
    if (this.data.order_type !== this.$constants.ORDER_TYPE.RIDE) {
      this.updateStepsInfo();
    } else {
      this.updateStepsRideInfo();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.order-process-status {
  display: flex;
  flex-direction: column;
  padding-top: 0.6rem;

  .created-date {
    text-align: left;
    font-size: 12px;
    margin-bottom: 10px;
  }

  .created-date::first-letter {
    text-transform: uppercase;
  }

  .steps {
    line-height: 1.5;
    color: #363a45;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
    display: flex;

    .steps-item {
      display: block;
      overflow: visible;
      min-height: 57px;

      .steps-item-tail {
        position: absolute;
        left: 12px;
        top: 0;
        height: 100%;
        width: 1px;
        padding: 30px 0 6px;
      }

      .steps-item-tail::after {
        background-color: #ccd6dd;
        height: 100%;
        width: 1px;
        box-sizing: border-box;
      }

      .steps-item-icon {
        float: left;
        margin-right: 15px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 24px;
        font-size: 12px;

        .steps-icon {
          line-height: 1;
          top: -1px;
          position: relative;
        }
      }

      .steps-item-content {
        min-height: 48px;
        overflow: hidden;
        display: block;
        text-align: left;

        .steps-item-title {
          line-height: 24px;
          font-size: 14px;
          padding-right: 12px;
        }

        .steps-item-description {
          padding-bottom: 12px;
          font-size: 13px;

          .fail-image {
            margin: 0;
            padding: 0;
            cursor: pointer;

            img {
              width: 120px;
              height: 120px;
              border: 1px dashed #cecece;
              margin: 5px 0 0 0;
              border-radius: 2px;
            }
          }

          .modal-background {
            background-color: hsla(0, 0%, 4%, 0.2);
          }

          .step-tool-tip {
            font-size: 13px;
            color: #7a8189;
          }

          .step-completed-time:first-letter {
            text-transform: uppercase;
          }

          .step-recipient-id {
            span:first-child {
              font-size: 13px;
              white-space: nowrap;
              color: #7a8189;
            }

            span:last-child {
              font-size: 14px;
              white-space: nowrap;
            }
          }
        }
      }
    }

    .steps-item:last-child .steps-item-tail::after {
      display: none;
    }
  }

  .steps-vertical {
    display: block;
  }

  .steps-item-tail::after {
    content: "";
    display: inline-block;
    background: #ccd6dd;
    height: 1px;
    border-radius: 1px;
    width: 100%;
    transition: background 0.3s;
  }

  .steps-item-icon {
    border: 1px solid #ccd6dd;
    transition: background-color 0.3s, border-color 0.3s;
  }

  .step-item-enable {
    .steps-item-icon {
      border-color: #f37336;
      background-color: #f37336;

      .steps-icon {
        font-size: 12px;
        color: #fff;
      }
    }

    .steps-item-description {
      color: #363a45;
    }
  }

  .step-item-disable {
    .steps-item-icon {
      border-color: #ccd6dd;
      background-color: #fff;

      .steps-icon {
        font-size: 12px;
        color: #ccd6dd;
      }
    }

    .steps-item-description,
    .steps-item-content {
      color: #ccd6dd;
    }
  }

  .step-item-fail {
    .steps-item-icon {
      border-color: #ef4d35;
      background-color: #ef4d35;

      .steps-icon {
        font-size: 12px;
        color: #fff;
      }
    }

    .steps-item-description,
    .steps-item-content {
      color: #ef4d35;
    }
  }
}

.steps-item {
  position: relative;
  display: inline-block;
  vertical-align: top;
  flex: 1;
  overflow: hidden;
}
</style>